import { useEffect } from 'react'
import i18n from 'translations/i18n'
import { logger } from 'utils/logging'
import moment from 'moment'

/** Re-asserts the Propstack-forced ?lang when i18n drifts (see EmbedConfig.context for the rationale). */
export const useEmbedLocaleSelfHeal = (enabled: boolean, locale: string | null) => {
  useEffect(() => {
    if (!enabled || !locale) return

    const healLocale = (language: string) => {
      if (language === locale) return

      logger.warn('Embed locale drifted from the forced ?lang, re-asserting', undefined, {
        context: {
          component: 'EmbedConfig',
          action: 'embedLocaleSelfHeal',
          metadata: { from: language, to: locale },
        },
      })
      i18n.changeLanguage(locale)
      moment.locale(locale)
    }

    healLocale(i18n.language)
    i18n.on('languageChanged', healLocale)
    return () => i18n.off('languageChanged', healLocale)
  }, [enabled, locale])
}
